import { render, staticRenderFns } from "./ComponentOriginatingSolicitorRevenue.vue?vue&type=template&id=9f354176"
import script from "./ComponentOriginatingSolicitorRevenue.vue?vue&type=script&lang=js"
export * from "./ComponentOriginatingSolicitorRevenue.vue?vue&type=script&lang=js"
import style0 from "./ComponentOriginatingSolicitorRevenue.vue?vue&type=style&index=0&id=9f354176&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports